import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { initMasquerade } from "../../redux/actions/auth/masquerade";
import { RootState } from "../../redux/reducers/root";

import "./Masquerade.css";
import "../ResetPassword/ResetPassword.css";
import AmpButton from "../../components/common/AmpButton/AmpButton";
import AmpLoadingSpinner from "../../components/common/AmpLoadingSpinner/AmpLoadingSpinner";
import { MasqueradeResponse } from "../../redux/reducers/getAuthReducer/masqueradeReducer";
import { setToastNotification } from "../../redux/actions/toastNotification/toastNotification";
import { setToken } from "../../redux/actions/auth/token";

export default function Masquerade() {

    const masqueradeResponse = useSelector((state: RootState) => state.authReducer.masquerade as MasqueradeResponse)
    const dispatch = useDispatch();
    const [requestSent, setRequestSent] = useState(false);
    const nav = useNavigate();

    const { token, id } = useParams();
    
    useEffect(() => {
        if (!requestSent) {
            setRequestSent(true);
            dispatch(initMasquerade(id as string, token as string));
        }
    }, [requestSent, setRequestSent, dispatch, id, token])

    useEffect(() => {
        if (masqueradeResponse["status"] !== 200 ){
            dispatch(setToastNotification(masqueradeResponse["message"] as string, "error"));
        } else if (masqueradeResponse["status"] === 200)  {
            dispatch(setToken(false));
            localStorage.clear();
        }

    }, [masqueradeResponse, dispatch])


    const beginMasquerade = () => {

        if (masqueradeResponse.tip && masqueradeResponse.tip !== "") {
            window.localStorage.setItem("amptip", masqueradeResponse.tip);
            window.localStorage.setItem("ampSplash", "true");
        }

        if(masqueradeResponse.tip2){
            window.localStorage.setItem("ampSplash", "true");
        }
        
        if (masqueradeResponse.token){
            window.localStorage.setItem("amptoken", masqueradeResponse.token);
            dispatch(setToken(true));
        }
        
        if (masqueradeResponse.user_profile_id){
            window.localStorage.setItem("userProfileId", masqueradeResponse.user_profile_id);
        }

        if (masqueradeResponse.exp ) {
            window.localStorage.setItem("sessionExp", masqueradeResponse.exp.toString());
        }

        if(masqueradeResponse.email) {
            window.localStorage.setItem("email", masqueradeResponse.email);
        }
        if(masqueradeResponse.is_agent) {
            window.localStorage.setItem("isAgent", masqueradeResponse.is_agent ? "Y" : "N");
        }

        nav("amp");

    }
 


    return (
        <>
            <div className="mas-top">
                <AmpLoadingSpinner loading={masqueradeResponse.loading}>
                    <div className="reset-container">
                        <div className="reset-header">
                            Masquerade
                        </div>
                        <div className="reset-content-top">
                            <div className="reset-content">
                                <p>You are about to masquerade as user: {masqueradeResponse.email}</p>
                            </div>
                            <div className="login-container-footer">
                                <div>
                                    <AmpButton type="submit" onClick={() => beginMasquerade()} text={"Masquerade"} />
                                </div>
                            </div>
                        </div>
                    </div>
                </AmpLoadingSpinner>

            </div>
        </>
    );
} 